export enum PricingsAssignmentType {
    ASSIGN_OFFER = 'ASSIGN_OFFER',
    UNASSIGN_OFFER = 'UNASSIGN_OFFER',
}
